<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Gestão"
      Pagina="Gestão"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-sm-12 col-md-5 col-lg-2">
            <div class="info-box">
              <span class="info-box-icon bg-warning elevation-1"><i class="fa fa-building"></i></span>
              <div class="info-box-content">
                <span class="info-box-text">Empresas</span>
                <span class="info-box-number">
                  {{dashboardGestao.empresas}}
                  <small>- 7 dias</small>
                </span>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-5 col-lg-2">
            <div class="info-box">
              <span class="info-box-icon bg-cyan elevation-1"><i class="fa fa-paperclip"></i></span>
              <div class="info-box-content">
                <span class="info-box-text">Processos</span>
                <span class="info-box-number">
                  {{dashboardGestao.processos}}
                  <small>- 7 dias</small>
                </span>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-5 col-lg-2">
            <div class="info-box">
              <span class="info-box-icon bg-black elevation-1"><i class="fa fa-commenting"></i></span>
              <div class="info-box-content">
                <span class="info-box-text">Atendimentos</span>
                <span class="info-box-number">
                  {{dashboardGestao.atendimentos}}
                  <small>- 7 dias</small>
                </span>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-5 col-lg-2">
            <div class="info-box">
              <span class="info-box-icon bg-gradient-green elevation-1"><i class="fa fa-circle-o-notch"></i></span>
              <div class="info-box-content">
                <span class="info-box-text">Movimentações</span>
                <span class="info-box-number">
                  {{dashboardGestao.movimentacao}}
                  <small>- 7 dias</small>
                </span>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-5 col-lg-2">
            <div class="info-box">
              <span class="info-box-icon bg-gradient-dark elevation-1"><i class="fa fa-users"></i></span>
              <div class="info-box-content">
                <span class="info-box-text">Acessos</span>
                <span class="info-box-number">
                   {{dashboardGestao.acessos}}
                  <small>- 7 dias</small>
                </span>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-5 col-lg-2">
            <div class="info-box">
              <span class="info-box-icon bg-gradient-indigo elevation-1"><i class="fa fa-comments"></i></span>
              <div class="info-box-content">
                <span class="info-box-text">Feedbacks</span>
                <span class="info-box-number">
                   {{dashboardGestao.feedbacks}}
                  <small>- 7 dias</small>
                </span>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 text-center">
            <button (click)="showFatura()" class="btn btn-primary btn-lg"><i class="fa fa-money"></i> Faturas</button>
            <button (click)="showEmpresa()" class="btn btn-primary btn-lg"><i class="fa fa-building-o"></i> Empresas</button>
            <button (click)="showFaq()" class="btn btn-primary btn-lg"><i class="fa fa-question"></i> FAQ</button>
            <button (click)="showFeedback()" class="btn btn-primary btn-lg"><i class="fa fa-comment"></i> Feedback</button>
            <button (click)="showNotificacao()" class="btn btn-primary btn-lg"><i class="fa fa-bell"></i> Notificação</button>
          </div>
        </div>
        <div *ngIf="fatura" class="row" style="margin-top: 20px;">
          <div class="col-md-12">
            <app-lista></app-lista>
          </div>
        </div>
        <div *ngIf="empresa" class="row" style="margin-top: 20px;">
          <div class="col-md-12">
            <app-empresas></app-empresas>
          </div>
        </div>
        <div *ngIf="faq" class="row" style="margin-top: 20px;">
          <div class="col-md-12">
            <app-faq></app-faq>
          </div>
        </div>
        <div *ngIf="help" class="row" style="margin-top: 20px;">
          <div class="col-md-12">
            <app-help></app-help>
          </div>
        </div>
        <div *ngIf="feedback" class="row" style="margin-top: 20px;">
          <div class="col-md-12">
            <app-feedback></app-feedback>
          </div>
        </div>
        <div *ngIf="notificacao" class="row" style="margin-top: 20px;">
          <div class="col-md-12">
            <app-lista-notificacao></app-lista-notificacao>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
